<template>
    <div class="com-part6">
		<title1 class="title-scale" type="1" title="作业执行情况" style="margin-top: 30px" />
        <!-- <div class="sub-title flex justify-end align-center">
            <div
                v-for="(item, i) in subTitle" :key="'subTitle' + i"
                @click="subTitleChange(i)">
                <p :class="{'at': i == subTitleAt}">{{ item.label }}</p>
            </div>
        </div> -->
        <div class="p-content mt-50">
			<!-- <div
				v-for="(item, i) in loadList"
				:key="'loadList' + i"
				class="load-list">
				<div class="flex item-t">
					<div class="icon-bg flex justify-center align-center">{{ i + 1 }}</div>
					<div>{{ item.ip }}</div>
				</div>
				<div class="flex item-b  align-center">
					<div class="flex1 item-l">
						<div class="solid" :style="{'width': `${item.num}%`}"></div>
					</div>
					<div class="flexs flex justify-center item-r">{{ item.num }}% </div>
				</div>
			</div> -->
			<myEchart
                v-if="zyzxqk"
                :id="'zyzxqk'"
                :options="batteryChargingData" />
        </div>
    </div>
</template>

<script>
import title1 from '@/views/exposition/components/title2'
import myEchart from "../charts/echarts"
import { dataInterface } from "@/api/dataInterfaceApi"
import { formatTime } from '@/utils/index'
import * as echarts from 'echarts5'
export default {
    components: {
        title1,
        myEchart
    },
    data() {
        return {
            subTitle: [
                {
                    label: 'GPU'
                },
                {
                    label: 'CPU'
                },
                {
                    label: '内存'
                }
            ],
            subTitleAt: 0,
			loadList: [
				{
					ip: '123123123123',
					num: 80
				},
				{
					ip: '123123123',
					num: 80
				},
				{
					ip: '2131231',
					num: 80
				},
				{
					ip: '123123',
					num: 80
				},
				{
					ip: '123123123',
					num: 40
				}
			],
			zyzxqk: false,
            batteryChargingData: {}
        }
    },
	mounted() {
		this.getbatteryCharging()
    },
	methods: {
        // 副标题切换
        subTitleChange(i) {
            this.subTitleAt = i
        },
        // 作业执行情况
		getbatteryCharging() {
			let params = { 
				enCode: 'computingpower-right-zyzxqk',
			}
			dataInterface.dataFaceApi(params).then(res => {
				console.log(res, '作业执行情况')
				let xAxisData = []
				let data1 = []
				res.forEach(item => {
					xAxisData.push(item.hour)
					// data1 充电机电流
					data1.push(item.measure)
				})
                this.batteryChargingData = {
                    title: {
                        text: '  个    ',
                        top: -5,
                        textStyle: {
                            fontSize: 20 // 设置标题字体大小
                        }
                    },
                    color: ['#4fc1ef', '#8bcfd0'],
                    tooltip: {
                        trigger: 'axis',
                        extraCssText:'width:160px;',
                        axisPointer: {
                            type: 'shadow',
                        },
                    },
                    xAxis: {
                        type: 'category',
                        data: xAxisData.splice(0,40),
                        axisLabel: {
                            show: true,
                            textStyle: {
                                // color: '#FFFFFF',
                                fontSize: '20',//字体大小
                            },
                            // interval: 0, // 每个标签都显示
                        },
                    },
//                     dataZoom: [
//     {
//       type: 'slider', // 滑动条形式的缩放
//       start: 0, // 默认起始位置为0%
//       end: 100, // 默认结束位置为100%
//     },
//   ],
                    yAxis: {
                        type: 'value',
                        axisLabel: {
                            fontSize: 20 // 设置x轴标签字体大小
                        }
                    },
                    series: [
                        {
                            name: '',
                            type: 'line',
                            smooth: true,
                            lineStyle: {
                                width: 0
                            },
                            showSymbol: false,
                            label: {
                                show: true,
                                position: 'top'
                            },
                            lineStyle: {
                                width: 2,
                                color: '#8CBBBE'
                            },
                            areaStyle: {
                                opacity: 0.8,
                                color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                                {
                                    offset: 0,
                                    color: '#8CBBBE'
                                },
                                {
                                    offset: 1,
                                    color: '#213037'
                                }
                                ])
                            },
                            tooltip: {
                                valueFormatter: function (value) {
                                    return value + ' 个';
                                }
                            },
                            emphasis: {
                                focus: 'series'
                            },
                            data: data1.splice(0,100)
                        },
                    ]
                }
				this.zyzxqk = true
			})
        }
    }
}
</script>

<style lang="scss" scoped>
@import '../comm.scss';
.com-part6 {
    width: 100%;
    height: 585px;
    .sub-title {
        font-size: $FontSize20;
        padding-top: 20px;
        height: 50px;
        > div {
            padding-right: 20px;
            > p {
                text-shadow: 0px 0px 9px #03B9BD;
                padding: 0 10px;
                position: relative;
                cursor: pointer;
                &.at {
                    &::after {
                        position: absolute;
                        bottom: -10px;
                        left: 0;
                        content: '';
                        width: 100%;
                        height: 2px;
                        background: linear-gradient(270deg, rgba(113, 186, 188, 0.0001) 0%, #71BBBD 33.33%, #6DB5B7 66.67%, rgba(111, 185, 187, 0.0001) 100%);
                    }
                }
            }
        }
    }

    .p-content {
        width: 100%;
        height: 450px;
		padding: 0 10px;
		box-sizing: border-box;
		.load-list {
			font-size: $FontSize24;
			.item-t {
				.icon-bg {
					width: 36px;
					height: 42px;
					background: url(~@/assets/images/computility/dispatch-icon6.png) center no-repeat;
					background-size: 100%;
					padding-bottom: 6px;
					box-sizing: border-box;
					font-size: $FontSize20;
					margin-right: 20px;
				}
			}
			.item-b {
				height: 50px;
				.item-l {
					height: 13px;
					background-color: rgba(208, 222, 238, 0.1);
					.solid {
						background: linear-gradient(270deg, #1FFAFF 1.64%, #E2FFFD 100%);
						position: relative;
						height: 13px;
						&::before {
							position: absolute;
							content: '';
							background-color: #fff;
							box-shadow: 0px 0px 4px 0px #EFD48E;
							width: 18px;
							height: 18px;
							right: -9px;
							top: -3px;
							border-radius: 50%;
						}
					}
				}
				.item-r {
					width: 80px;
				}
			}
		}
    }
}
</style>